import { __assign } from "tslib";
import * as React from 'react';
import { StyledIconBase } from '@styled-icons/styled-icon';
export var Discourse = React.forwardRef(function (props, ref) {
  var attrs = {
    "fill": "currentColor",
    "xmlns": "http://www.w3.org/2000/svg"
  };
  return React.createElement(StyledIconBase, __assign({
    iconAttrs: attrs,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 24 24"
  }, props, {
    ref: ref
  }), React.createElement("path", {
    d: "M12.077 3C7.149 3 3 6.96 3 11.843V21l9.075-.01c4.928 0 8.925-4.11 8.925-8.993C21 7.113 17 3 12.077 3zm3.92 12.859a5.568 5.568 0 01-6.102 1.043l-3.595.805 1.001-3.192a5.435 5.435 0 01.11-5.415 5.55 5.55 0 014.753-2.678v.001h.006a5.533 5.533 0 015.131 3.438 5.442 5.442 0 01-1.304 5.998z",
    key: "k0"
  }));
});
Discourse.displayName = 'Discourse';
export var DiscourseDimensions = {
  height: 24,
  width: 24
};